<!-- usage-progress-bar.component.html -->
<p-card styleClass="h-full">
  <!-- Component Title -->
   <div class="flex flex-row justify-between items-center gap-2 pb-2">
     <div class="text-xl font-bold">
       <i class="pi pi-info-circle cursor-pointer hover:text-primary" pTooltip="The total number of credits available to you."></i>
       Credit Balance
      </div>
      <span class="text-xl font-extrabold text-primary flex flex-row items-center gap-2">
        {{ totalCreditLimit() | number : "1.0-0" }}
      </span>
    </div>


  <!-- Progress Bar Container -->
  <div class="relative w-full h-8 bg-gray-300 dark:bg-gray-700 rounded-full overflow-hidden">
    <!-- The actual filled portion of the bar, representing credits used -->
    <div
      class="h-full rounded-full transition-all duration-500 ease-out"
      [ngClass]="barFillColor()"
      [style.width.%]="displayBarPercentage()"
    ></div>

    @if (prepaidCredits() > 0 && prepaidCredits() < totalCreditLimit()) {
      <!-- 
        Prepaid Credits Threshold Marker:
          A dashed line indicating where prepaid credits end and subscription credits begin.
          It's only shown if there are prepaid credits and they don't make up the entire limit. 
          This is a visual indicator to help users understand where their credits are coming from.
        -->
      <div
        class="absolute top-0 h-full border-l-2 border-dashed border-gray-400"
        [style.left.%]="prepaidThresholdPercentage()"
        [title]="'Prepaid Credit Threshold: ' + prepaidCredits() + ' credits'"
      ></div>
    }

    <!-- Text overlay on the bar, showing the percentage used -->
    <div
      class="absolute inset-0 flex items-center justify-center text-sm font-bold text-white mix-blend-difference"
    >
      {{ usedPercentage() | number : "1.0-0" }}% Used
    </div>
  </div>

  @if(renewalDate()) {
    <div class="flex flex-row justify-center items-center gap-2">
      <span class="text-md text-gray-500 dark:text-gray-400">Resets:</span>
      <span class="text-md text-primary">
        {{ renewalDate() | date : "MM/dd/yyyy" }}
      </span>
    </div>
  }

  <!-- Over-usage warning message -->
  @if (creditsUsed() > totalCreditLimit()) {
  <p class="text-red-600 font-semibold text-center mt-4">
    You have exceeded your credit limit by
    {{ creditsUsed() - totalCreditLimit() | number : "1.0-0" }} credits!
  </p>
  }

  <!-- Detailed Breakdown of all credit values -->
  <div class="pt-2 flex flex-col gap-1 justify-between">
    <div class="flex flex-row justify-between items-center">
      <span class="text-md text-gray-500 dark:text-gray-400">
        <i class="pi pi-info-circle cursor-pointer hover:text-primary" pTooltip="Your one-time credit balance."></i>
        One-Time Credits:
      </span>
      <span class="text-md text-primary font-bold">
        {{ prepaidCredits() | number : "1.0-0" }}
      </span>
    </div>
    <div class="flex flex-row justify-between items-center">
      <span class="text-md text-gray-500 dark:text-gray-400">
        <i class="pi pi-info-circle cursor-pointer hover:text-primary" pTooltip="Your total credit limit. Billing is prepaid-only for now, so this equals your available prepaid credits."></i>
        Credit Limit:
      </span>
      <span class="text-md text-primary font-bold">
        {{ totalCreditLimit() | number : "1.0-0" }}
      </span>
    </div>
  </div>

  @if(viewMode() === 'navbar') {
    <div class="flex flex-row justify-between items-center gap-2">
      <div class="text-sm text-blue-500 cursor-pointer hover:text-primary hover:underline" [routerLink]="['/app/billing/plans']">Manage</div>
      <div class="text-sm text-blue-500 cursor-pointer hover:text-primary hover:underline" (click)="refresh()">Refresh</div>
      <div class="text-sm text-blue-500 cursor-pointer hover:text-primary hover:underline" [routerLink]="['/app/usage/history']">View Usage</div>
      <!-- <span class="text-md text-gray-500 dark:text-gray-400" (click)="refresh()">Refresh</span> -->
    </div>
  }


</p-card>
